module.exports = __webpack_public_path__ + "df55878d4755d0ce8475094115e0dd5b.jpg";